// source: plan.reviewer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var icc_chapters_pb = require('./icc.chapters_pb.js');
goog.object.extend(proto, icc_chapters_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ArchitecturalPlan', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.CodeProvisionReference', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.CodeRelevance', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ComplianceStatus', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.EvidenceCitation', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.EvidenceCitation.Confidence', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.EvidenceKind', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.EvidenceProvenance', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.EvidenceProvenance.ResolutionMethod', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.FileComplianceCoverage', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.FileCompliancePageHit', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.FileComplianceSummary', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.FileOverviewSummary', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.FilterCase', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ModelStamp', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.OcrTextSelector', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.PageComplianceReport', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.PlanComplianceReport', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.Relevance', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.SummaryAvailability', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.SummaryFreshness', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.displayName = 'proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ModelStamp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ModelStamp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ModelStamp.displayName = 'proto.org.codetricks.construction.code.assistant.ModelStamp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.displayName = 'proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ArchitecturalPlan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.displayName = 'proto.org.codetricks.construction.code.assistant.ArchitecturalPlan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.displayName = 'proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.displayName = 'proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.displayName = 'proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.displayName = 'proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.displayName = 'proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.displayName = 'proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.displayName = 'proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.displayName = 'proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.FileComplianceCoverage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.displayName = 'proto.org.codetricks.construction.code.assistant.FileComplianceCoverage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.displayName = 'proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.displayName = 'proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.FileComplianceSummary.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.FileComplianceSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.FileComplianceSummary.displayName = 'proto.org.codetricks.construction.code.assistant.FileComplianceSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.oneofGroups_);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.displayName = 'proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.FileCompliancePageHit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.displayName = 'proto.org.codetricks.construction.code.assistant.FileCompliancePageHit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.displayName = 'proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.displayName = 'proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.displayName = 'proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.displayName = 'proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.FileOverviewSummary.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.FileOverviewSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.FileOverviewSummary.displayName = 'proto.org.codetricks.construction.code.assistant.FileOverviewSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.EvidenceCitation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.EvidenceCitation.displayName = 'proto.org.codetricks.construction.code.assistant.EvidenceCitation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.displayName = 'proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.OcrTextSelector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.OcrTextSelector.displayName = 'proto.org.codetricks.construction.code.assistant.OcrTextSelector';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.CodeProvisionReference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.CodeProvisionReference.displayName = 'proto.org.codetricks.construction.code.assistant.CodeProvisionReference';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.EvidenceProvenance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.EvidenceProvenance.displayName = 'proto.org.codetricks.construction.code.assistant.EvidenceProvenance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.displayName = 'proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.PageComplianceReport.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.PageComplianceReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.PageComplianceReport.displayName = 'proto.org.codetricks.construction.code.assistant.PageComplianceReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.displayName = 'proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.PlanComplianceReport.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.PlanComplianceReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.PlanComplianceReport.displayName = 'proto.org.codetricks.construction.code.assistant.PlanComplianceReport';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.toObject = function(includeInstance, msg) {
  var f, obj = {
subSection: (f = msg.getSubSection()) && icc_chapters_pb.SubSection.toObject(includeInstance, f),
chapter: (f = msg.getChapter()) && icc_chapters_pb.Chapter.toObject(includeInstance, f),
pageApplicabilityReportsList: jspb.Message.toObjectList(msg.getPageApplicabilityReportsList(),
    proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport}
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport;
  return proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport}
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new icc_chapters_pb.SubSection;
      reader.readMessage(value,icc_chapters_pb.SubSection.deserializeBinaryFromReader);
      msg.setSubSection(value);
      break;
    case 2:
      var value = new icc_chapters_pb.Chapter;
      reader.readMessage(value,icc_chapters_pb.Chapter.deserializeBinaryFromReader);
      msg.setChapter(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.deserializeBinaryFromReader);
      msg.addPageApplicabilityReports(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubSection();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      icc_chapters_pb.SubSection.serializeBinaryToWriter
    );
  }
  f = message.getChapter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      icc_chapters_pb.Chapter.serializeBinaryToWriter
    );
  }
  f = message.getPageApplicabilityReportsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.icc.api.legacy.SubSection sub_section = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection}
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.getSubSection = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} */ (
    jspb.Message.getWrapperField(this, icc_chapters_pb.SubSection, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport} returns this
*/
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.setSubSection = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.clearSubSection = function() {
  return this.setSubSection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.hasSubSection = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.icc.api.legacy.Chapter chapter = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter}
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.getChapter = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} */ (
    jspb.Message.getWrapperField(this, icc_chapters_pb.Chapter, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport} returns this
*/
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.setChapter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.clearChapter = function() {
  return this.setChapter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.hasChapter = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated SectionToPageApplicabilityReport page_applicability_reports = 3;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport>}
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.getPageApplicabilityReportsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport, 3));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport>} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport} returns this
*/
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.setPageApplicabilityReportsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport}
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.addPageApplicabilityReports = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionApplicabilityReport.prototype.clearPageApplicabilityReportsList = function() {
  return this.setPageApplicabilityReportsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ModelStamp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ModelStamp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.toObject = function(includeInstance, msg) {
  var f, obj = {
modelName: jspb.Message.getFieldWithDefault(msg, 1, ""),
profileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
createdTime: (f = msg.getCreatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ModelStamp}
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ModelStamp;
  return proto.org.codetricks.construction.code.assistant.ModelStamp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ModelStamp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ModelStamp}
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ModelStamp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ModelStamp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProfileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string model_name = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.prototype.getModelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ModelStamp} returns this
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.prototype.setModelName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string profile_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.prototype.getProfileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ModelStamp} returns this
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.prototype.setProfileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp created_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.prototype.getCreatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.ModelStamp} returns this
*/
proto.org.codetricks.construction.code.assistant.ModelStamp.prototype.setCreatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.ModelStamp} returns this
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.prototype.clearCreatedTime = function() {
  return this.setCreatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ModelStamp.prototype.hasCreatedTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.toObject = function(includeInstance, msg) {
  var f, obj = {
pageNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
summary: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
pageId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 5, ""),
pageFolderPath: jspb.Message.getFieldWithDefault(msg, 6, ""),
pageMarkdown: jspb.Message.getFieldWithDefault(msg, 7, ""),
explanationMarkdown: jspb.Message.getFieldWithDefault(msg, 8, ""),
modelStamp: (f = msg.getModelStamp()) && proto.org.codetricks.construction.code.assistant.ModelStamp.toObject(includeInstance, f),
fileId: jspb.Message.getFieldWithDefault(msg, 10, ""),
pagePhysicalWidthInches: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
pagePhysicalHeightInches: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
pageSizeSource: jspb.Message.getFieldWithDefault(msg, 13, ""),
pageSizeCorrectionFactor: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
transcriptSourceNotice: jspb.Message.getFieldWithDefault(msg, 15, ""),
ocrText: jspb.Message.getFieldWithDefault(msg, 16, ""),
ocrTextTruncated: jspb.Message.getBooleanFieldWithDefault(msg, 17, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage;
  return proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageFolderPath(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageMarkdown(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExplanationMarkdown(value);
      break;
    case 9:
      var value = new proto.org.codetricks.construction.code.assistant.ModelStamp;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ModelStamp.deserializeBinaryFromReader);
      msg.setModelStamp(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPagePhysicalWidthInches(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPagePhysicalHeightInches(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageSizeSource(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPageSizeCorrectionFactor(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTranscriptSourceNotice(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setOcrText(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOcrTextTruncated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPageFolderPath();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPageMarkdown();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getExplanationMarkdown();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getModelStamp();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.org.codetricks.construction.code.assistant.ModelStamp.serializeBinaryToWriter
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPagePhysicalWidthInches();
  if (f !== 0.0) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = message.getPagePhysicalHeightInches();
  if (f !== 0.0) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = message.getPageSizeSource();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPageSizeCorrectionFactor();
  if (f !== 0.0) {
    writer.writeFloat(
      14,
      f
    );
  }
  f = message.getTranscriptSourceNotice();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getOcrText();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOcrTextTruncated();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
};


/**
 * optional int32 page_number = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setTitle = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.clearTitle = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string summary = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setSummary = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.clearSummary = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string page_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getPageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setPageId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.clearPageId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.hasPageId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string architectural_plan_id = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string page_folder_path = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getPageFolderPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setPageFolderPath = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string page_markdown = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getPageMarkdown = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setPageMarkdown = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string explanation_markdown = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getExplanationMarkdown = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setExplanationMarkdown = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional ModelStamp model_stamp = 9;
 * @return {?proto.org.codetricks.construction.code.assistant.ModelStamp}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getModelStamp = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ModelStamp} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.ModelStamp, 9));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ModelStamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
*/
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setModelStamp = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.clearModelStamp = function() {
  return this.setModelStamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.hasModelStamp = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string file_id = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional float page_physical_width_inches = 11;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getPagePhysicalWidthInches = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setPagePhysicalWidthInches = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional float page_physical_height_inches = 12;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getPagePhysicalHeightInches = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setPagePhysicalHeightInches = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional string page_size_source = 13;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getPageSizeSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setPageSizeSource = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional float page_size_correction_factor = 14;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getPageSizeCorrectionFactor = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setPageSizeCorrectionFactor = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional string transcript_source_notice = 15;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getTranscriptSourceNotice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setTranscriptSourceNotice = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string ocr_text = 16;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getOcrText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setOcrText = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional bool ocr_text_truncated = 17;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.getOcrTextTruncated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.prototype.setOcrTextTruncated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.toObject = function(includeInstance, msg) {
  var f, obj = {
pagesList: jspb.Message.toObjectList(msg.getPagesList(),
    proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlan}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ArchitecturalPlan;
  return proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlan}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.deserializeBinaryFromReader);
      msg.addPages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ArchitecturalPlanPage pages = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage>}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.prototype.getPagesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage>} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlan} returns this
*/
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.prototype.setPagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.prototype.addPages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlan} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlan.prototype.clearPagesList = function() {
  return this.setPagesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList;
  return proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addArchitecturalPlanIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string architectural_plan_ids = 1;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.prototype.getArchitecturalPlanIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.prototype.setArchitecturalPlanIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.prototype.addArchitecturalPlanIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList} returns this
 */
proto.org.codetricks.construction.code.assistant.ArchitecturalPlanIdList.prototype.clearArchitecturalPlanIdsList = function() {
  return this.setArchitecturalPlanIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.toObject = function(includeInstance, msg) {
  var f, obj = {
page: (f = msg.getPage()) && proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.toObject(includeInstance, f),
applicable: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
applicabilityReason: jspb.Message.getFieldWithDefault(msg, 3, ""),
iccSectionId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport}
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport;
  return proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport}
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApplicable(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicabilityReason(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccSectionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.serializeBinaryToWriter
    );
  }
  f = message.getApplicable();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getApplicabilityReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIccSectionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional ArchitecturalPlanPage page = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage}
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.getPage = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport} returns this
*/
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.hasPage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool applicable = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.getApplicable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.setApplicable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string applicability_reason = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.getApplicabilityReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.setApplicabilityReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string icc_section_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.getIccSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionToPageApplicabilityReport.prototype.setIccSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.toObject = function(includeInstance, msg) {
  var f, obj = {
pageNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
pageTitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
applicabilityRationale: jspb.Message.getFieldWithDefault(msg, 3, ""),
iccSectionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
iccBookId: jspb.Message.getFieldWithDefault(msg, 5, ""),
relevance: jspb.Message.getFieldWithDefault(msg, 6, 0),
generatedByModel: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdTime: (f = msg.getCreatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis;
  return proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicabilityRationale(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccSectionId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 6:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.Relevance} */ (reader.readEnum());
      msg.setRelevance(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setGeneratedByModel(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getApplicabilityRationale();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIccSectionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRelevance();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getGeneratedByModel();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 page_number = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string page_title = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.getPageTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.setPageTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string applicability_rationale = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.getApplicabilityRationale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.setApplicabilityRationale = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string icc_section_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.getIccSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.setIccSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string icc_book_id = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Relevance relevance = 6;
 * @return {!proto.org.codetricks.construction.code.assistant.Relevance}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.getRelevance = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.Relevance} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.Relevance} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.setRelevance = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string generated_by_model = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.getGeneratedByModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.setGeneratedByModel = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_time = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.getCreatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} returns this
*/
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.setCreatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.clearCreatedTime = function() {
  return this.setCreatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.prototype.hasCreatedTime = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.toObject = function(includeInstance, msg) {
  var f, obj = {
pageApplicabilityAnalysisList: jspb.Message.toObjectList(msg.getPageApplicabilityAnalysisList(),
    proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList;
  return proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.deserializeBinaryFromReader);
      msg.addPageApplicabilityAnalysis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageApplicabilityAnalysisList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PageApplicabilityAnalysis page_applicability_analysis = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis>}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.prototype.getPageApplicabilityAnalysisList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis>} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList} returns this
*/
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.prototype.setPageApplicabilityAnalysisList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis}
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.prototype.addPageApplicabilityAnalysis = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysis, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList} returns this
 */
proto.org.codetricks.construction.code.assistant.PageApplicabilityAnalysisList.prototype.clearPageApplicabilityAnalysisList = function() {
  return this.setPageApplicabilityAnalysisList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.toObject = function(includeInstance, msg) {
  var f, obj = {
subSection: (f = msg.getSubSection()) && icc_chapters_pb.SubSection.toObject(includeInstance, f),
chapter: (f = msg.getChapter()) && icc_chapters_pb.Chapter.toObject(includeInstance, f),
page: (f = msg.getPage()) && proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.toObject(includeInstance, f),
complianceStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
complianceStatement: jspb.Message.getFieldWithDefault(msg, 5, ""),
generatedByModel: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage;
  return proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new icc_chapters_pb.SubSection;
      reader.readMessage(value,icc_chapters_pb.SubSection.deserializeBinaryFromReader);
      msg.setSubSection(value);
      break;
    case 2:
      var value = new icc_chapters_pb.Chapter;
      reader.readMessage(value,icc_chapters_pb.Chapter.deserializeBinaryFromReader);
      msg.setChapter(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceStatus} */ (reader.readEnum());
      msg.setComplianceStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplianceStatement(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setGeneratedByModel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubSection();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      icc_chapters_pb.SubSection.serializeBinaryToWriter
    );
  }
  f = message.getChapter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      icc_chapters_pb.Chapter.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage.serializeBinaryToWriter
    );
  }
  f = message.getComplianceStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getComplianceStatement();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getGeneratedByModel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional io.icc.api.legacy.SubSection sub_section = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.getSubSection = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} */ (
    jspb.Message.getWrapperField(this, icc_chapters_pb.SubSection, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} returns this
*/
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.setSubSection = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.clearSubSection = function() {
  return this.setSubSection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.hasSubSection = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.icc.api.legacy.Chapter chapter = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.getChapter = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} */ (
    jspb.Message.getWrapperField(this, icc_chapters_pb.Chapter, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} returns this
*/
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.setChapter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.clearChapter = function() {
  return this.setChapter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.hasChapter = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ArchitecturalPlanPage page = 3;
 * @return {?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.getPage = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage, 3));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} returns this
*/
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.hasPage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ComplianceStatus compliance_status = 4;
 * @return {!proto.org.codetricks.construction.code.assistant.ComplianceStatus}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.getComplianceStatus = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.ComplianceStatus} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.setComplianceStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string compliance_statement = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.getComplianceStatement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.setComplianceStatement = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string generated_by_model = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.getGeneratedByModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage} returns this
 */
proto.org.codetricks.construction.code.assistant.SectionComplianceReportForPlanPage.prototype.setGeneratedByModel = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
iccBookId: jspb.Message.getFieldWithDefault(msg, 3, ""),
iccSectionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest}
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest;
  return proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest}
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccSectionId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIccSectionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string icc_book_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string icc_section_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.getIccSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.setIccSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string file_id = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.toObject = function(includeInstance, msg) {
  var f, obj = {
request: (f = msg.getRequest()) && proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.toObject(includeInstance, f),
complianceStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
complianceStatement: jspb.Message.getFieldWithDefault(msg, 3, ""),
complianceStatementTldr: jspb.Message.getFieldWithDefault(msg, 4, ""),
generatedByModel: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdTime: (f = msg.getCreatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
evidenceChainList: jspb.Message.toObjectList(msg.getEvidenceChainList(),
    proto.org.codetricks.construction.code.assistant.EvidenceCitation.toObject, includeInstance),
sourcePageRevision: jspb.Message.getFieldWithDefault(msg, 8, ""),
catGraphId: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport;
  return proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    case 2:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceStatus} */ (reader.readEnum());
      msg.setComplianceStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplianceStatement(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplianceStatementTldr(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setGeneratedByModel(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedTime(value);
      break;
    case 7:
      var value = new proto.org.codetricks.construction.code.assistant.EvidenceCitation;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.EvidenceCitation.deserializeBinaryFromReader);
      msg.addEvidenceChain(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourcePageRevision(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCatGraphId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest.serializeBinaryToWriter
    );
  }
  f = message.getComplianceStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getComplianceStatement();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getComplianceStatementTldr();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGeneratedByModel();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEvidenceChainList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.org.codetricks.construction.code.assistant.EvidenceCitation.serializeBinaryToWriter
    );
  }
  f = message.getSourcePageRevision();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCatGraphId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional GetPageSectionComplianceReportRequest request = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.getRequest = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.GetPageSectionComplianceReportRequest|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
*/
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ComplianceStatus compliance_status = 2;
 * @return {!proto.org.codetricks.construction.code.assistant.ComplianceStatus}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.getComplianceStatus = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.ComplianceStatus} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.setComplianceStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string compliance_statement = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.getComplianceStatement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.setComplianceStatement = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string compliance_statement_tldr = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.getComplianceStatementTldr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.setComplianceStatementTldr = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string generated_by_model = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.getGeneratedByModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.setGeneratedByModel = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp created_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.getCreatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
*/
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.setCreatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.clearCreatedTime = function() {
  return this.setCreatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.hasCreatedTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated EvidenceCitation evidence_chain = 7;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.EvidenceCitation>}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.getEvidenceChainList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.EvidenceCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.EvidenceCitation, 7));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.EvidenceCitation>} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
*/
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.setEvidenceChainList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.addEvidenceChain = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.org.codetricks.construction.code.assistant.EvidenceCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.clearEvidenceChainList = function() {
  return this.setEvidenceChainList([]);
};


/**
 * optional string source_page_revision = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.getSourcePageRevision = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.setSourcePageRevision = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string cat_graph_id = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.getCatGraphId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.prototype.setCatGraphId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.toObject = function(includeInstance, msg) {
  var f, obj = {
canonicalSectionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem}
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem;
  return proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem}
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCanonicalSectionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCanonicalSectionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string canonical_section_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.prototype.getCanonicalSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem} returns this
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.prototype.setCanonicalSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem} returns this
 */
proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.toObject = function(includeInstance, msg) {
  var f, obj = {
filePageCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
ingestedPageCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
evaluatedPageCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
pendingPageCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
failedPageCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
stalePageCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
notApplicablePageCount: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.FileComplianceCoverage;
  return proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFilePageCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIngestedPageCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEvaluatedPageCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPendingPageCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFailedPageCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStalePageCount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNotApplicablePageCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilePageCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIngestedPageCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getEvaluatedPageCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPendingPageCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getFailedPageCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStalePageCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getNotApplicablePageCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 file_page_count = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.getFilePageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.setFilePageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 ingested_page_count = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.getIngestedPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.setIngestedPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 evaluated_page_count = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.getEvaluatedPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.setEvaluatedPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 pending_page_count = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.getPendingPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.setPendingPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 failed_page_count = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.getFailedPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.setFailedPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 stale_page_count = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.getStalePageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.setStalePageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 not_applicable_page_count = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.getNotApplicablePageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.prototype.setNotApplicablePageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.repeatedFields_ = [4,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.toObject = function(includeInstance, msg) {
  var f, obj = {
iccBookId: jspb.Message.getFieldWithDefault(msg, 1, ""),
canonicalSectionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
hierarchyList: jspb.Message.toObjectList(msg.getHierarchyList(),
    proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.toObject, includeInstance),
depth: jspb.Message.getFieldWithDefault(msg, 5, 0),
hasChildren: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
isRollup: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
highPageCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
mediumPageCount: jspb.Message.getFieldWithDefault(msg, 9, 0),
lowPageCount: jspb.Message.getFieldWithDefault(msg, 10, 0),
evaluatedPageCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
missingPageCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
stalePageCount: jspb.Message.getFieldWithDefault(msg, 13, 0),
notApplicablePageCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
fileRelevance: jspb.Message.getFieldWithDefault(msg, 15, 0),
fileRelevanceSummary: jspb.Message.getFieldWithDefault(msg, 16, ""),
relevantPageCount: jspb.Message.getFieldWithDefault(msg, 17, 0),
relevanceSourcePagesList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow;
  return proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCanonicalSectionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = new proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.deserializeBinaryFromReader);
      msg.addHierarchy(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDepth(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasChildren(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRollup(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHighPageCount(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMediumPageCount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLowPageCount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEvaluatedPageCount(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMissingPageCount(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStalePageCount(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNotApplicablePageCount(value);
      break;
    case 15:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.CodeRelevance} */ (reader.readEnum());
      msg.setFileRelevance(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileRelevanceSummary(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRelevantPageCount(value);
      break;
    case 18:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRelevanceSourcePages(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCanonicalSectionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHierarchyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem.serializeBinaryToWriter
    );
  }
  f = message.getDepth();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getHasChildren();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsRollup();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getHighPageCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getMediumPageCount();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getLowPageCount();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getEvaluatedPageCount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getMissingPageCount();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getStalePageCount();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getNotApplicablePageCount();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getFileRelevance();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getFileRelevanceSummary();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getRelevantPageCount();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getRelevanceSourcePagesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      18,
      f
    );
  }
};


/**
 * optional string icc_book_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string canonical_section_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getCanonicalSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setCanonicalSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ComplianceHierarchyItem hierarchy = 4;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem>}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getHierarchyList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem, 4));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem>} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
*/
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setHierarchyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.addHierarchy = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.org.codetricks.construction.code.assistant.ComplianceHierarchyItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.clearHierarchyList = function() {
  return this.setHierarchyList([]);
};


/**
 * optional int32 depth = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool has_children = 6;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getHasChildren = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setHasChildren = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_rollup = 7;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getIsRollup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setIsRollup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional int32 high_page_count = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getHighPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setHighPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 medium_page_count = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getMediumPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setMediumPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 low_page_count = 10;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getLowPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setLowPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 evaluated_page_count = 11;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getEvaluatedPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setEvaluatedPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 missing_page_count = 12;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getMissingPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setMissingPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 stale_page_count = 13;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getStalePageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setStalePageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 not_applicable_page_count = 14;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getNotApplicablePageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setNotApplicablePageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional CodeRelevance file_relevance = 15;
 * @return {!proto.org.codetricks.construction.code.assistant.CodeRelevance}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getFileRelevance = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.CodeRelevance} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.CodeRelevance} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setFileRelevance = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string file_relevance_summary = 16;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getFileRelevanceSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setFileRelevanceSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int32 relevant_page_count = 17;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getRelevantPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setRelevantPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * repeated int32 relevance_source_pages = 18;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.getRelevanceSourcePagesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.setRelevanceSourcePagesList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.addRelevanceSourcePages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.prototype.clearRelevanceSourcePagesList = function() {
  return this.setRelevanceSourcePagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest}
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest;
  return proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest}
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetFileComplianceSummaryRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.FileComplianceSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
coverage: (f = msg.getCoverage()) && proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.toObject(includeInstance, f),
rowsList: jspb.Message.toObjectList(msg.getRowsList(),
    proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.toObject, includeInstance),
freshness: jspb.Message.getFieldWithDefault(msg, 5, 0),
sourceVersion: jspb.Message.getFieldWithDefault(msg, 6, ""),
builtVersion: jspb.Message.getFieldWithDefault(msg, 7, ""),
generatedTime: (f = msg.getGeneratedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.FileComplianceSummary;
  return proto.org.codetricks.construction.code.assistant.FileComplianceSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.FileComplianceCoverage;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.deserializeBinaryFromReader);
      msg.setCoverage(value);
      break;
    case 4:
      var value = new proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.deserializeBinaryFromReader);
      msg.addRows(value);
      break;
    case 5:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.SummaryFreshness} */ (reader.readEnum());
      msg.setFreshness(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceVersion(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuiltVersion(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setGeneratedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.FileComplianceSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCoverage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.FileComplianceCoverage.serializeBinaryToWriter
    );
  }
  f = message.getRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow.serializeBinaryToWriter
    );
  }
  f = message.getFreshness();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSourceVersion();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBuiltVersion();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getGeneratedTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional FileComplianceCoverage coverage = 3;
 * @return {?proto.org.codetricks.construction.code.assistant.FileComplianceCoverage}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.getCoverage = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.FileComplianceCoverage} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.FileComplianceCoverage, 3));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.FileComplianceCoverage|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.setCoverage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.clearCoverage = function() {
  return this.setCoverage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.hasCoverage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated FileComplianceSummaryRow rows = 4;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow>}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.getRowsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow, 4));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow>} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.setRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.addRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.org.codetricks.construction.code.assistant.FileComplianceSummaryRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.clearRowsList = function() {
  return this.setRowsList([]);
};


/**
 * optional SummaryFreshness freshness = 5;
 * @return {!proto.org.codetricks.construction.code.assistant.SummaryFreshness}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.getFreshness = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.SummaryFreshness} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.SummaryFreshness} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.setFreshness = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string source_version = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.getSourceVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.setSourceVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string built_version = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.getBuiltVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.setBuiltVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp generated_time = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.getGeneratedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.setGeneratedTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.clearGeneratedTime = function() {
  return this.setGeneratedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceSummary.prototype.hasGeneratedTime = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.oneofGroups_ = [[5,8]];

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.FilterCase = {
  FILTER_NOT_SET: 0,
  RISK: 5,
  COVERAGE_STATE: 8
};

/**
 * @return {proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.FilterCase}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.getFilterCase = function() {
  return /** @type {proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.FilterCase} */(jspb.Message.computeOneofCase(this, proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
iccBookId: jspb.Message.getFieldWithDefault(msg, 3, ""),
canonicalSectionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
risk: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
coverageState: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
pageSize: jspb.Message.getFieldWithDefault(msg, 6, 0),
pageToken: jspb.Message.getFieldWithDefault(msg, 7, ""),
sourceVersion: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest;
  return proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCanonicalSectionId(value);
      break;
    case 5:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket} */ (reader.readEnum());
      msg.setRisk(value);
      break;
    case 8:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState} */ (reader.readEnum());
      msg.setCoverageState(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCanonicalSectionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = /** @type {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSourceVersion();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string icc_book_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string canonical_section_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.getCanonicalSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.setCanonicalSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional ComplianceRiskBucket risk = 5;
 * @return {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.getRisk = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.setRisk = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.clearRisk = function() {
  return jspb.Message.setOneofField(this, 5, proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.hasRisk = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional FileComplianceCoverageState coverage_state = 8;
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.getCoverageState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.setCoverageState = function(value) {
  return jspb.Message.setOneofField(this, 8, proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.clearCoverageState = function() {
  return jspb.Message.setOneofField(this, 8, proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.hasCoverageState = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 page_size = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string page_token = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string source_version = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.getSourceVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesRequest.prototype.setSourceVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.toObject = function(includeInstance, msg) {
  var f, obj = {
pageNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
sheetId: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageTitle: jspb.Message.getFieldWithDefault(msg, 3, ""),
risk: jspb.Message.getFieldWithDefault(msg, 4, 0),
reportCreatedTime: (f = msg.getReportCreatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
stale: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
coverageState: jspb.Message.getFieldWithDefault(msg, 7, 0),
matchedCanonicalSectionId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.FileCompliancePageHit;
  return proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSheetId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageTitle(value);
      break;
    case 4:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket} */ (reader.readEnum());
      msg.setRisk(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setReportCreatedTime(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStale(value);
      break;
    case 7:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState} */ (reader.readEnum());
      msg.setCoverageState(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchedCanonicalSectionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSheetId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRisk();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getReportCreatedTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStale();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getCoverageState();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getMatchedCanonicalSectionId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional int32 page_number = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sheet_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.getSheetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.setSheetId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string page_title = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.getPageTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.setPageTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ComplianceRiskBucket risk = 4;
 * @return {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.getRisk = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.setRisk = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp report_created_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.getReportCreatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} returns this
*/
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.setReportCreatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.clearReportCreatedTime = function() {
  return this.setReportCreatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.hasReportCreatedTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool stale = 6;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.getStale = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.setStale = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional FileComplianceCoverageState coverage_state = 7;
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.getCoverageState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.setCoverageState = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string matched_canonical_section_id = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.getMatchedCanonicalSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.prototype.setMatchedCanonicalSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagesList: jspb.Message.toObjectList(msg.getPagesList(),
    proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.toObject, includeInstance),
nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
sourceVersion: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse;
  return proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.FileCompliancePageHit;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.deserializeBinaryFromReader);
      msg.addPages(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.FileCompliancePageHit.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSourceVersion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated FileCompliancePageHit pages = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit>}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.getPagesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.FileCompliancePageHit, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit>} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.setPagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.FileCompliancePageHit}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.addPages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.FileCompliancePageHit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.clearPagesList = function() {
  return this.setPagesList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_count = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string source_version = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.getSourceVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.ListFileCompliancePagesResponse.prototype.setSourceVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest}
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest;
  return proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest}
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetFileOverviewSummaryRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.toObject = function(includeInstance, msg) {
  var f, obj = {
summary: jspb.Message.getFieldWithDefault(msg, 1, ""),
availability: jspb.Message.getFieldWithDefault(msg, 2, 0),
sourcePageCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
filePageCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
sourceVersionsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
generator: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection}
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection;
  return proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection}
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 2:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.SummaryAvailability} */ (reader.readEnum());
      msg.setAvailability(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSourcePageCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFilePageCount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addSourceVersions(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setGenerator(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAvailability();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSourcePageCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFilePageCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSourceVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getGenerator();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string summary = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} returns this
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SummaryAvailability availability = 2;
 * @return {!proto.org.codetricks.construction.code.assistant.SummaryAvailability}
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.getAvailability = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.SummaryAvailability} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.SummaryAvailability} value
 * @return {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} returns this
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.setAvailability = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 source_page_count = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.getSourcePageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} returns this
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.setSourcePageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 file_page_count = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.getFilePageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} returns this
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.setFilePageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated string source_versions = 5;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.getSourceVersionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} returns this
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.setSourceVersionsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} returns this
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.addSourceVersions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} returns this
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.clearSourceVersionsList = function() {
  return this.setSourceVersionsList([]);
};


/**
 * optional string generator = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.getGenerator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} returns this
 */
proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.prototype.setGenerator = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
pageNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
highestCurrentRisk: jspb.Message.getFieldWithDefault(msg, 2, 0),
coverageState: jspb.Message.getFieldWithDefault(msg, 3, 0),
sourcePageRevision: jspb.Message.getFieldWithDefault(msg, 4, ""),
highRiskCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
mediumRiskCount: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus}
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus;
  return proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus}
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 2:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket} */ (reader.readEnum());
      msg.setHighestCurrentRisk(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState} */ (reader.readEnum());
      msg.setCoverageState(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourcePageRevision(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHighRiskCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMediumRiskCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getHighestCurrentRisk();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCoverageState();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSourcePageRevision();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHighRiskCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMediumRiskCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional int32 page_number = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus} returns this
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ComplianceRiskBucket highest_current_risk = 2;
 * @return {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket}
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.getHighestCurrentRisk = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket} value
 * @return {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus} returns this
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.setHighestCurrentRisk = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional FileComplianceCoverageState coverage_state = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState}
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.getCoverageState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState} value
 * @return {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus} returns this
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.setCoverageState = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string source_page_revision = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.getSourcePageRevision = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus} returns this
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.setSourcePageRevision = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 high_risk_count = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.getHighRiskCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus} returns this
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.setHighRiskCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 medium_risk_count = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.getMediumRiskCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus} returns this
 */
proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.prototype.setMediumRiskCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.FileOverviewSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
contents: (f = msg.getContents()) && proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.toObject(includeInstance, f),
applicabilityPosture: (f = msg.getApplicabilityPosture()) && proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.toObject(includeInstance, f),
compliancePosture: (f = msg.getCompliancePosture()) && proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.toObject(includeInstance, f),
builtVersion: jspb.Message.getFieldWithDefault(msg, 4, ""),
generatedTime: (f = msg.getGeneratedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
pageStatusesList: jspb.Message.toObjectList(msg.getPageStatusesList(),
    proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.FileOverviewSummary;
  return proto.org.codetricks.construction.code.assistant.FileOverviewSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.deserializeBinaryFromReader);
      msg.setContents(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.deserializeBinaryFromReader);
      msg.setApplicabilityPosture(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.deserializeBinaryFromReader);
      msg.setCompliancePosture(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuiltVersion(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setGeneratedTime(value);
      break;
    case 6:
      var value = new proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.deserializeBinaryFromReader);
      msg.addPageStatuses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.FileOverviewSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContents();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.serializeBinaryToWriter
    );
  }
  f = message.getApplicabilityPosture();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.serializeBinaryToWriter
    );
  }
  f = message.getCompliancePosture();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection.serializeBinaryToWriter
    );
  }
  f = message.getBuiltVersion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGeneratedTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPageStatusesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional ExecutiveSummarySection contents = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.getContents = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.setContents = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.clearContents = function() {
  return this.setContents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.hasContents = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ExecutiveSummarySection applicability_posture = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.getApplicabilityPosture = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.setApplicabilityPosture = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.clearApplicabilityPosture = function() {
  return this.setApplicabilityPosture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.hasApplicabilityPosture = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ExecutiveSummarySection compliance_posture = 3;
 * @return {?proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.getCompliancePosture = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection, 3));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ExecutiveSummarySection|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.setCompliancePosture = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.clearCompliancePosture = function() {
  return this.setCompliancePosture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.hasCompliancePosture = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string built_version = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.getBuiltVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.setBuiltVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp generated_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.getGeneratedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.setGeneratedTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.clearGeneratedTime = function() {
  return this.setGeneratedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.hasGeneratedTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated FilePageNavigationStatus page_statuses = 6;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus>}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.getPageStatusesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus, 6));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus>} value
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.setPageStatusesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus}
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.addPageStatuses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.org.codetricks.construction.code.assistant.FilePageNavigationStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.FileOverviewSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.FileOverviewSummary.prototype.clearPageStatusesList = function() {
  return this.setPageStatusesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.EvidenceCitation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.toObject = function(includeInstance, msg) {
  var f, obj = {
pageNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
sheetId: jspb.Message.getFieldWithDefault(msg, 3, ""),
regionPath: jspb.Message.getFieldWithDefault(msg, 4, ""),
excerpt: jspb.Message.getFieldWithDefault(msg, 5, ""),
confidence: jspb.Message.getFieldWithDefault(msg, 6, 0),
citationId: jspb.Message.getFieldWithDefault(msg, 7, ""),
claimId: jspb.Message.getFieldWithDefault(msg, 8, ""),
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 9, ""),
evidenceKind: jspb.Message.getFieldWithDefault(msg, 10, 0),
normalizedBox: (f = msg.getNormalizedBox()) && proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.toObject(includeInstance, f),
textSelector: (f = msg.getTextSelector()) && proto.org.codetricks.construction.code.assistant.OcrTextSelector.toObject(includeInstance, f),
codeReference: (f = msg.getCodeReference()) && proto.org.codetricks.construction.code.assistant.CodeProvisionReference.toObject(includeInstance, f),
provenance: (f = msg.getProvenance()) && proto.org.codetricks.construction.code.assistant.EvidenceProvenance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.EvidenceCitation;
  return proto.org.codetricks.construction.code.assistant.EvidenceCitation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSheetId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionPath(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setExcerpt(value);
      break;
    case 6:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.EvidenceCitation.Confidence} */ (reader.readEnum());
      msg.setConfidence(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCitationId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setClaimId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 10:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.EvidenceKind} */ (reader.readEnum());
      msg.setEvidenceKind(value);
      break;
    case 11:
      var value = new proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.deserializeBinaryFromReader);
      msg.setNormalizedBox(value);
      break;
    case 12:
      var value = new proto.org.codetricks.construction.code.assistant.OcrTextSelector;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.OcrTextSelector.deserializeBinaryFromReader);
      msg.setTextSelector(value);
      break;
    case 13:
      var value = new proto.org.codetricks.construction.code.assistant.CodeProvisionReference;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.CodeProvisionReference.deserializeBinaryFromReader);
      msg.setCodeReference(value);
      break;
    case 14:
      var value = new proto.org.codetricks.construction.code.assistant.EvidenceProvenance;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.EvidenceProvenance.deserializeBinaryFromReader);
      msg.setProvenance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.EvidenceCitation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSheetId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRegionPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExcerpt();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getCitationId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getClaimId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEvidenceKind();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getNormalizedBox();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.serializeBinaryToWriter
    );
  }
  f = message.getTextSelector();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.org.codetricks.construction.code.assistant.OcrTextSelector.serializeBinaryToWriter
    );
  }
  f = message.getCodeReference();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.org.codetricks.construction.code.assistant.CodeProvisionReference.serializeBinaryToWriter
    );
  }
  f = message.getProvenance();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.org.codetricks.construction.code.assistant.EvidenceProvenance.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.Confidence = {
  CONFIDENCE_UNSPECIFIED: 0,
  CONFIDENCE_HIGH: 1,
  CONFIDENCE_MEDIUM: 2,
  CONFIDENCE_LOW: 3
};

/**
 * optional int32 page_number = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string sheet_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getSheetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setSheetId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string region_path = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getRegionPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setRegionPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string excerpt = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getExcerpt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setExcerpt = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Confidence confidence = 6;
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation.Confidence}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getConfidence = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.EvidenceCitation.Confidence} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceCitation.Confidence} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string citation_id = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getCitationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setCitationId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string claim_id = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getClaimId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string architectural_plan_id = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional EvidenceKind evidence_kind = 10;
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceKind}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getEvidenceKind = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.EvidenceKind} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceKind} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setEvidenceKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional NormalizedBoundingBox normalized_box = 11;
 * @return {?proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getNormalizedBox = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox, 11));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
*/
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setNormalizedBox = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.clearNormalizedBox = function() {
  return this.setNormalizedBox(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.hasNormalizedBox = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional OcrTextSelector text_selector = 12;
 * @return {?proto.org.codetricks.construction.code.assistant.OcrTextSelector}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getTextSelector = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.OcrTextSelector} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.OcrTextSelector, 12));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.OcrTextSelector|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
*/
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setTextSelector = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.clearTextSelector = function() {
  return this.setTextSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.hasTextSelector = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional CodeProvisionReference code_reference = 13;
 * @return {?proto.org.codetricks.construction.code.assistant.CodeProvisionReference}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getCodeReference = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.CodeProvisionReference} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.CodeProvisionReference, 13));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.CodeProvisionReference|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
*/
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setCodeReference = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.clearCodeReference = function() {
  return this.setCodeReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.hasCodeReference = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional EvidenceProvenance provenance = 14;
 * @return {?proto.org.codetricks.construction.code.assistant.EvidenceProvenance}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.getProvenance = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.EvidenceProvenance} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.EvidenceProvenance, 14));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.EvidenceProvenance|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
*/
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.setProvenance = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.clearProvenance = function() {
  return this.setProvenance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.EvidenceCitation.prototype.hasProvenance = function() {
  return jspb.Message.getField(this, 14) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.toObject = function(includeInstance, msg) {
  var f, obj = {
xMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
yMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
xMax: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
yMax: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox}
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox;
  return proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox}
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setXMin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYMin(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setXMax(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getXMin();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getYMin();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getXMax();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getYMax();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional double x_min = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.prototype.getXMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox} returns this
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.prototype.setXMin = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y_min = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.prototype.getYMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox} returns this
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.prototype.setYMin = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double x_max = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.prototype.getXMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox} returns this
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.prototype.setXMax = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double y_max = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.prototype.getYMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox} returns this
 */
proto.org.codetricks.construction.code.assistant.NormalizedBoundingBox.prototype.setYMax = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.OcrTextSelector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.OcrTextSelector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.toObject = function(includeInstance, msg) {
  var f, obj = {
version: jspb.Message.getFieldWithDefault(msg, 1, 0),
exact: jspb.Message.getFieldWithDefault(msg, 2, ""),
occurrence: jspb.Message.getFieldWithDefault(msg, 3, 0),
prefix: jspb.Message.getFieldWithDefault(msg, 4, ""),
suffix: jspb.Message.getFieldWithDefault(msg, 5, ""),
fingerprint: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.OcrTextSelector}
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.OcrTextSelector;
  return proto.org.codetricks.construction.code.assistant.OcrTextSelector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.OcrTextSelector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.OcrTextSelector}
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExact(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOccurrence(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrefix(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuffix(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFingerprint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.OcrTextSelector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.OcrTextSelector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getExact();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOccurrence();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPrefix();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSuffix();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFingerprint();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 version = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.OcrTextSelector} returns this
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string exact = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.getExact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.OcrTextSelector} returns this
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.setExact = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 occurrence = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.getOccurrence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.OcrTextSelector} returns this
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.setOccurrence = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string prefix = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.getPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.OcrTextSelector} returns this
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.setPrefix = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string suffix = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.getSuffix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.OcrTextSelector} returns this
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.setSuffix = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string fingerprint = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.getFingerprint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.OcrTextSelector} returns this
 */
proto.org.codetricks.construction.code.assistant.OcrTextSelector.prototype.setFingerprint = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.CodeProvisionReference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.toObject = function(includeInstance, msg) {
  var f, obj = {
bookId: jspb.Message.getFieldWithDefault(msg, 1, ""),
documentSlug: jspb.Message.getFieldWithDefault(msg, 2, ""),
chapterSlug: jspb.Message.getFieldWithDefault(msg, 3, ""),
chapterTitle: jspb.Message.getFieldWithDefault(msg, 4, ""),
sectionId: jspb.Message.getFieldWithDefault(msg, 5, ""),
visibleLabel: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference}
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.CodeProvisionReference;
  return proto.org.codetricks.construction.code.assistant.CodeProvisionReference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference}
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBookId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentSlug(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChapterSlug(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChapterTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectionId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisibleLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.CodeProvisionReference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBookId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocumentSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChapterSlug();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChapterTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSectionId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getVisibleLabel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string book_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.getBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference} returns this
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.setBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string document_slug = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.getDocumentSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference} returns this
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.setDocumentSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string chapter_slug = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.getChapterSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference} returns this
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.setChapterSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string chapter_title = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.getChapterTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference} returns this
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.setChapterTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string section_id = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.getSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference} returns this
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.setSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string visible_label = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.getVisibleLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.CodeProvisionReference} returns this
 */
proto.org.codetricks.construction.code.assistant.CodeProvisionReference.prototype.setVisibleLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.EvidenceProvenance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.toObject = function(includeInstance, msg) {
  var f, obj = {
resolutionMethod: jspb.Message.getFieldWithDefault(msg, 1, 0),
generatedByModel: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageArtifactRevision: jspb.Message.getFieldWithDefault(msg, 3, ""),
regionHierarchyRevision: jspb.Message.getFieldWithDefault(msg, 4, ""),
resolvedTime: (f = msg.getResolvedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.EvidenceProvenance;
  return proto.org.codetricks.construction.code.assistant.EvidenceProvenance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance.ResolutionMethod} */ (reader.readEnum());
      msg.setResolutionMethod(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGeneratedByModel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageArtifactRevision(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionHierarchyRevision(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setResolvedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.EvidenceProvenance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResolutionMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getGeneratedByModel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageArtifactRevision();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRegionHierarchyRevision();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getResolvedTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.ResolutionMethod = {
  RESOLUTION_METHOD_UNSPECIFIED: 0,
  RESOLUTION_METHOD_DETERMINISTIC: 1,
  RESOLUTION_METHOD_AGENT_TRACE: 2,
  RESOLUTION_METHOD_INDEX_LOOKUP: 3,
  RESOLUTION_METHOD_INFERRED: 4
};

/**
 * optional ResolutionMethod resolution_method = 1;
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance.ResolutionMethod}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.getResolutionMethod = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance.ResolutionMethod} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance.ResolutionMethod} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.setResolutionMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string generated_by_model = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.getGeneratedByModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.setGeneratedByModel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string page_artifact_revision = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.getPageArtifactRevision = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.setPageArtifactRevision = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string region_hierarchy_revision = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.getRegionHierarchyRevision = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.setRegionHierarchyRevision = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp resolved_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.getResolvedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance} returns this
*/
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.setResolvedTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceProvenance} returns this
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.clearResolvedTime = function() {
  return this.setResolvedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.EvidenceProvenance.prototype.hasResolvedTime = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
iccBookId: jspb.Message.getFieldWithDefault(msg, 3, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest}
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest;
  return proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest}
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string icc_book_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPageComplianceReportRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.PageComplianceReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.PageComplianceReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.toObject = function(includeInstance, msg) {
  var f, obj = {
pageSectionComplianceReportsList: jspb.Message.toObjectList(msg.getPageSectionComplianceReportsList(),
    proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.toObject, includeInstance),
reportSummary: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.PageComplianceReport}
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.PageComplianceReport;
  return proto.org.codetricks.construction.code.assistant.PageComplianceReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.PageComplianceReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.PageComplianceReport}
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.deserializeBinaryFromReader);
      msg.addPageSectionComplianceReports(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReportSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.PageComplianceReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.PageComplianceReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSectionComplianceReportsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport.serializeBinaryToWriter
    );
  }
  f = message.getReportSummary();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated PageSectionComplianceReport page_section_compliance_reports = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport>}
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.prototype.getPageSectionComplianceReportsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport>} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageComplianceReport} returns this
*/
proto.org.codetricks.construction.code.assistant.PageComplianceReport.prototype.setPageSectionComplianceReportsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport}
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.prototype.addPageSectionComplianceReports = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.PageSectionComplianceReport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.PageComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.prototype.clearPageSectionComplianceReportsList = function() {
  return this.setPageSectionComplianceReportsList([]);
};


/**
 * optional string report_summary = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.prototype.getReportSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.PageComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PageComplianceReport.prototype.setReportSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
iccBookId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest}
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest;
  return proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest}
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string icc_book_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.GetPlanComplianceReportRequest.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.PlanComplianceReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.PlanComplianceReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.toObject = function(includeInstance, msg) {
  var f, obj = {
pageComplianceReportsList: jspb.Message.toObjectList(msg.getPageComplianceReportsList(),
    proto.org.codetricks.construction.code.assistant.PageComplianceReport.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.PlanComplianceReport}
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.PlanComplianceReport;
  return proto.org.codetricks.construction.code.assistant.PlanComplianceReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.PlanComplianceReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.PlanComplianceReport}
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.PageComplianceReport;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.PageComplianceReport.deserializeBinaryFromReader);
      msg.addPageComplianceReports(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.PlanComplianceReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.PlanComplianceReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageComplianceReportsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.PageComplianceReport.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PageComplianceReport page_compliance_reports = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.PageComplianceReport>}
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.prototype.getPageComplianceReportsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.PageComplianceReport>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.PageComplianceReport, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.PageComplianceReport>} value
 * @return {!proto.org.codetricks.construction.code.assistant.PlanComplianceReport} returns this
*/
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.prototype.setPageComplianceReportsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.PageComplianceReport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.PageComplianceReport}
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.prototype.addPageComplianceReports = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.PageComplianceReport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.PlanComplianceReport} returns this
 */
proto.org.codetricks.construction.code.assistant.PlanComplianceReport.prototype.clearPageComplianceReportsList = function() {
  return this.setPageComplianceReportsList([]);
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.Relevance = {
  NOT_RELEVANT: 0,
  HIGH: 1,
  MEDIUM: 2,
  LOW: 3
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.ComplianceStatus = {
  UNKNOWN: 0,
  NON_COMPLIANT: 1,
  NOT_APPLICABLE: 2,
  COMPLIANT: 3,
  PARTIALLY_COMPLIANT: 4
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.ComplianceRiskBucket = {
  COMPLIANCE_RISK_BUCKET_UNSPECIFIED: 0,
  COMPLIANCE_RISK_BUCKET_HIGH: 1,
  COMPLIANCE_RISK_BUCKET_MEDIUM: 2,
  COMPLIANCE_RISK_BUCKET_LOW: 3
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.FileComplianceCoverageState = {
  FILE_COMPLIANCE_COVERAGE_STATE_UNSPECIFIED: 0,
  FILE_COMPLIANCE_COVERAGE_STATE_NOT_APPLICABLE: 1,
  FILE_COMPLIANCE_COVERAGE_STATE_STALE: 2,
  FILE_COMPLIANCE_COVERAGE_STATE_MISSING: 3,
  FILE_COMPLIANCE_COVERAGE_STATE_PENDING: 4,
  FILE_COMPLIANCE_COVERAGE_STATE_FAILED: 5
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.SummaryFreshness = {
  SUMMARY_FRESHNESS_UNSPECIFIED: 0,
  SUMMARY_FRESHNESS_CURRENT: 1,
  SUMMARY_FRESHNESS_REBUILDING: 2,
  SUMMARY_FRESHNESS_STALE: 3
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.CodeRelevance = {
  CODE_RELEVANCE_UNSPECIFIED: 0,
  CODE_RELEVANCE_HIGH: 1,
  CODE_RELEVANCE_MEDIUM: 2,
  CODE_RELEVANCE_LOW: 3,
  CODE_RELEVANCE_NOT_RELEVANT: 4
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.SummaryAvailability = {
  SUMMARY_AVAILABILITY_UNSPECIFIED: 0,
  SUMMARY_AVAILABILITY_CURRENT: 1,
  SUMMARY_AVAILABILITY_PARTIAL: 2,
  SUMMARY_AVAILABILITY_UNAVAILABLE: 3,
  SUMMARY_AVAILABILITY_STALE: 4
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.EvidenceKind = {
  EVIDENCE_KIND_UNSPECIFIED: 0,
  EVIDENCE_KIND_PAGE: 1,
  EVIDENCE_KIND_REGION: 2,
  EVIDENCE_KIND_OCR_TEXT: 3,
  EVIDENCE_KIND_CODE_PROVISION: 4
};

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant);
